import { useState } from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Stack,
  Toolbar,
} from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import TipsAndUpdatesRoundedIcon from "@mui/icons-material/TipsAndUpdatesRounded";

import LeftMobileMenu from "./LeftMobileMenu/LeftMobileMenu";
import logo from "../../images/logo-e.png";
import "./Header.css";
import "./responsive.css";
import SearchComponent from "../search/SearchComponent";

const classes = [1, 2, 3, 4, 5, 8, 9, 10];

function Header() {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <header className="site-header">
      <AppBar position="static" elevation={0} className="site-header__bar">
        <Container maxWidth="lg">
          <Toolbar disableGutters className="site-header__toolbar">
            <Box className="site-header__brand">
              <Link to="/home" aria-label="Грамота, головна сторінка">
                <img alt="Грамота" src={logo} />
              </Link>
            </Box>

            <Box className="site-header__search">
              <SearchComponent />
            </Box>

            <Stack direction="row" spacing={1} className="site-header__actions">
              <Button
                component={Link}
                to="/instruction"
                color="inherit"
                startIcon={<InfoOutlinedIcon />}
              >
                Інструкція
              </Button>
              <Button
                component="a"
                href="tel:+380686604958"
                color="inherit"
                className="site-header__phone"
                startIcon={<PhoneIphoneRoundedIcon />}
              >
                +38 068 660 49 58
              </Button>
            </Stack>

            <IconButton
              color="inherit"
              className="site-header__menu-button"
              onClick={() => setShowMenu(true)}
              aria-label="Відкрити меню"
            >
              <MenuRoundedIcon />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      <Box component="nav" className="site-nav">
        <Container maxWidth="xl" className="site-nav__inner">
          <Stack component="ul" direction="row" className="site-nav__links">
            <li>
              <Button component={Link} to="/home" startIcon={<HomeRoundedIcon />}>
                Головна
              </Button>
            </li>
            <li className="site-nav__dropdown">
              <Button startIcon={<SchoolRoundedIcon />}>Клас</Button>
              <Box className="site-nav__menu">
                {classes.map((classNumber) => (
                  <Button
                    key={classNumber}
                    component={Link}
                    to={`/class/${classNumber}`}
                  >
                    Клас {classNumber}
                  </Button>
                ))}
              </Box>
            </li>
            <li className="site-nav__dropdown">
              <Button startIcon={<HelpRoundedIcon />}>Допомога</Button>
              <Box className="site-nav__menu">
                <Button component={Link} to="/instruction">
                  Інструкція
                </Button>
                <Button component={Link} to="/about">
                  Про додаток
                </Button>
                <Button component={Link} to="/author_info">
                  Про підручники
                </Button>
                <Button
                  component="a"
                  href="https://www.gramota.kiev.ua"
                  target="_blank"
                  rel="noreferrer"
                >
                  Сайт видавництва
                </Button>
              </Box>
            </li>
            <li>
              <Button component={Link} to="/author-task-demo" startIcon={<TipsAndUpdatesRoundedIcon />}>
                Для авторів
              </Button>
            </li>
          </Stack>
        </Container>
      </Box>

      <LeftMobileMenu show={showMenu} handleClose={() => setShowMenu(false)} />
    </header>
  );
}

export default Header;
